import React from "react";

export const CubeQueryWizardMemberRemovalWarning = ({
  member,
  variableName,
}) => {
  const msg = `Member ${member} was removed from filter item ${variableName}.`;
  return <div>{msg}</div>;
};
